import {CREATE_DRAFT, FETCH_DRAFT, FETCH_ALL_DRAFTS, FETCH_ALL_DRAFTS_LOADING} from "../actions/actions-index";
import * as _ from "lodash";

export function draft (state = {}, action) {

    switch (action.type) {
        case FETCH_ALL_DRAFTS:
            let currentSeasons = action.payload.currentAndFutureSeasons;
            let pastSeasons = action.payload.pastSeasons;
            let allDraftsState = { ...state };
            allDraftsState.currentSeasons = _.mapKeys(currentSeasons, 'id');
            allDraftsState.pastSeasons = _.mapKeys(pastSeasons, 'id');
            return allDraftsState;
        case FETCH_DRAFT:
            const draft = action.payload;
            const newState = { ...state };
            newState[draft.id] = draft;
            return newState;
        case CREATE_DRAFT:
            return state;
        default:
            return state;
    }
}

export function draftsLoading(state = {}, action) {
    switch (action.type) {
        case FETCH_ALL_DRAFTS_LOADING:
            return {isLoading: action.payload}
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducers-draft.js